/**
 * Los textos por defecto y las aria de las piezas comunes en cada idioma (componentes.md, «Piezas en inglés», G928, G996):
 * RV Menu, RV Selector y RV Contador. Sin `idioma`, o con `es`, quedan exactamente igual que siempre. Los textos que pasa
 * la pantalla (`etiqueta`, `texto` de cada opción…) van ya en su idioma.
 */
export type IdiomaPieza = 'es' | 'en';

export const TEXTOS_PIEZAS = {
    es: {
        masOpciones: 'Más opciones',
        atras: 'Atrás',
        cerrar: 'Cerrar',
        cerrarMenu: 'Cerrar el menú',
        submenu: 'Submenú',
        buscar: 'Buscar',
        sinResultados: (q: string) => `Sin resultados para «${q}».`,
        cantidad: 'Cantidad',
        restar: 'Restar',
        sumar: 'Sumar',
        minimo: (n: number) => `Mínimo ${String(n)}`,
        maximo: (n: number) => `Máximo ${String(n)}`,
    },
    en: {
        masOpciones: 'More options',
        atras: 'Back',
        cerrar: 'Close',
        cerrarMenu: 'Close the menu',
        submenu: 'Submenu',
        buscar: 'Search',
        sinResultados: (q: string) => `No results for “${q}”.`,
        cantidad: 'Quantity',
        restar: 'Decrease',
        sumar: 'Increase',
        minimo: (n: number) => `Minimum ${String(n)}`,
        maximo: (n: number) => `Maximum ${String(n)}`,
    },
} as const;
